import { defineComponent as _defineComponent } from 'vue'

export const SVG_ICONS = ['color', 'fill-none', 'fill-white', 'fill-solid']

const __default__ = {}

import { ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'WhiteboardSvgIcon',
  props: {
    name: { default: 'highlight' },
    size: { default: 24 },
    isHovered: { type: Boolean, default: false },
    isActive: { type: Boolean, default: false },
    isSelected: { type: Boolean, default: false },
    colorScheme: { default: 'dark' },
    fillTextColorClass: { default: '' },
    isOpaqueOutlineColor: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { name: string, size: number, isHovered: boolean, isActive: boolean, isSelected: boolean, colorScheme: 'dark' | 'light', fillTextColorClass: string | null, isOpaqueOutlineColor: boolean };


const canAnimate = ref(false)
watch(
  () => props.isSelected,
  () => {
    canAnimate.value = true
  },
)

const COLOR_UNSELECTED_INNER_PATH =
  'M24 4C35.0457 4 44 12.9543 44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4Z'
const COLOR_SELECTED_INNER_PATH =
  'M24 16C28.4183 16 32 19.5817 32 24C32 28.4183 28.4183 32 24 32C19.5817 32 16 28.4183 16 24C16 19.5817 19.5817 16 24 16Z'
const COLOR_UNSELECTED_OUTER_PATH =
  'M41 24C41 14.6112 33.3888 7 24 7C14.6112 7 7 14.6112 7 24C7 33.3888 14.6112 41 24 41C33.3888 41 41 33.3888 41 24ZM44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44C35.0457 44 44 35.0457 44 24Z'
const COLOR_SELECTED_OUTER_PATH =
  'M38 24C38 16.268 31.732 10 24 10C16.268 10 10 16.268 10 24C10 31.732 16.268 38 24 38C31.732 38 38 31.732 38 24ZM44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44C35.0457 44 44 35.0457 44 24Z'

return { __sfc: true,SVG_ICONS, props, canAnimate, COLOR_UNSELECTED_INNER_PATH, COLOR_SELECTED_INNER_PATH, COLOR_UNSELECTED_OUTER_PATH, COLOR_SELECTED_OUTER_PATH }
}

})